module.exports = __webpack_public_path__ + "static/media/growth_help.038681b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/growth_help.png
// module id = 46
// module chunks = 0